"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CombineDialog = void 0;
var RequestClearShoppingCache = _interopRequireWildcard(require("@ori-events/request-clear-shopping-cache"));
var RequestShoppingContextEvent = _interopRequireWildcard(require("@ori-events/request-shopping-context"));
var _components = require("@ori-ui/components");
var _checkoutUtils = require("@ori/checkout-utils");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _presentationHttp = require("@ori/presentation-http");
var _shoppingContext = require("@ori/shopping-context");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../hooks");
var _CombineDialogShipment = require("./CombineDialogShipment");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
/* eslint-disable react/jsx-no-bind -- no issues */ const CombineDialog = (param)=>{
    let { isCombineDialogOpen, setIsCombineDialogOpen, subscriptions = [], mutateSubscriptions } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const sessionId = (0, _shoppingContext.useSessionId)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    const apiClient = (0, _globalApiClientReact.useApiClient)();
    const { headers } = (0, _presentationHttp.useHeaders)();
    const groupedSubscriptions = subscriptions.reduce((acc, subscription)=>{
        var _subscription_nextShipment;
        var _subscription_nextShipment_toISOString;
        const shipmentDate = (_subscription_nextShipment_toISOString = (_subscription_nextShipment = subscription.nextShipment) === null || _subscription_nextShipment === void 0 ? void 0 : _subscription_nextShipment.toISOString()) !== null && _subscription_nextShipment_toISOString !== void 0 ? _subscription_nextShipment_toISOString : 'no-date';
        const updatedAcc = {
            ...acc
        };
        var _updatedAcc_shipmentDate;
        (updatedAcc[shipmentDate] = (_updatedAcc_shipmentDate = updatedAcc[shipmentDate]) !== null && _updatedAcc_shipmentDate !== void 0 ? _updatedAcc_shipmentDate : []).push(subscription);
        return updatedAcc;
    }, {});
    const sortedGroupedSubscriptions = Object.keys(groupedSubscriptions).sort((a, b)=>a === 'no-date' ? 1 : b === 'no-date' ? -1 : new Date(a).getTime() - new Date(b).getTime()).reduce((acc, key)=>{
        const newAcc = {
            ...acc
        };
        var _groupedSubscriptions_key;
        newAcc[key] = (_groupedSubscriptions_key = groupedSubscriptions[key]) !== null && _groupedSubscriptions_key !== void 0 ? _groupedSubscriptions_key : [];
        return newAcc;
    }, {});
    const subscriptionShipments = Object.entries(sortedGroupedSubscriptions).map((param)=>{
        let [shipmentDate, subscriptionsWithShipment] = param;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_CombineDialogShipment.CombineDialogShipment, {
            subscriptions: subscriptionsWithShipment
        }, shipmentDate);
    });
    const combineOrder = (0, _react.useCallback)(async ()=>{
        const subscriptionsToCombine = subscriptions.map((subscription)=>({
                ...subscription,
                status: _globalApiClientReact.GlobalShoppingPersonalSubscriptionDtoStatus.Dropped
            }));
        try {
            await (0, _globalApiClientReact.updateShoppingSessionPersonalSubscriptions)(apiClient, sessionId, {
                collection: subscriptionsToCombine
            }, {
                ...headers,
                // eslint-disable-next-line @typescript-eslint/naming-convention -- correct naming
                'x-referer': '/shopping/basket',
                [_fetching.PLACEMENT]: 'ship-it-together'
            });
            window.dispatchEvent(new CustomEvent(RequestClearShoppingCache.Name));
            if (mutateSubscriptions) {
                await mutateSubscriptions();
            }
            // setTimeout is set so the shopping context is requested after caches are cleared
            setTimeout(()=>{
                window.dispatchEvent(new CustomEvent(RequestShoppingContextEvent.Name));
            });
        } catch (error) {
            (0, _checkoutUtils.showErrorNotification)();
        }
        setIsCombineDialogOpen(false);
    }, [
        subscriptions,
        apiClient,
        sessionId,
        headers,
        mutateSubscriptions,
        setIsCombineDialogOpen
    ]);
    const footerContent = (0, _react.useMemo)(()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.ButtonsWrapper, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
                    fullWidth: true,
                    maxWidth: "330px",
                    color: "primary",
                    variant: "contained",
                    "data-testid": getTestId('combine-order-button'),
                    onClick: combineOrder,
                    children: formatMessage('add')
                }, "confirm"),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
                    fullWidth: true,
                    maxWidth: "330px",
                    color: "default",
                    variant: "text",
                    onClick: ()=>setIsCombineDialogOpen(false),
                    children: formatMessage('cancel')
                }, "cancel")
            ]
        }), [
        combineOrder,
        formatMessage,
        getTestId,
        setIsCombineDialogOpen
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Dialog, {
        hideCloseButton: true,
        size: "small",
        open: isCombineDialogOpen,
        header: formatMessage('combineYourOrder'),
        footer: footerContent,
        "aria-label": formatMessage('combineYourOrder'),
        "data-testid": getTestId('combine-dialog'),
        onClose: ()=>setIsCombineDialogOpen(false),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.DialogContent, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.DialogDescription, {
                    variant: "body1",
                    children: formatMessage('enjoyFreeShipping')
                }),
                subscriptionShipments
            ]
        })
    });
};
exports.CombineDialog = CombineDialog;
